import api from 'api';

export const loadAudienceTable = api('POST /api/audiences/grid');
export const loadAudienceDetails = api('GET /api/audiences/:id/details');
export const loadAudience = api('GET /api/audiences/:id');
export const createAudience = api('POST /api/audiences');
export const updateAudience = api('PUT /api/audiences/:id');

export const startExportAudience = api('GET /api/audiences/export/start');
export const checkExportAudience = api(
  'GET /api/audiences/export/:jobId/status'
);

export const archiveAudience = api('POST /api/audiences/:id/archive');
export const restoreAudience = api('POST /api/audiences/:id/restore');

export const syncAudience = api('POST /api/audiences/:id/sync');
export const batchSyncAudience = api('POST /api/audiences/batch/sync');

export const deleteAudience = api('POST /api/audiences/:id/delete');
export const batchDeleteAudience = api('POST /api/audiences/batch/delete');
export const loadEstimate = api('POST /api/audiences/estimate');

export const toggleAutoSyncAudience = api(
  'PATCH /api/audiences/:id/toggle-auto-sync'
);

export const loadAudienceActionsLog = api(
  'GET /api/audiences/:id/details/actionsLog'
);

export const uploadFile = api('POST /api/audiences/upload');

export const exportGridAudiences = api('POST /api/audiences/grid/export');
